import type { NavigationLinkProps } from 'src/core/common/components/NavigationLink/NavigationLink';
import { useFeature } from 'src/core/common/hooks/useFeature';
import { useTranslation } from 'src/core/common/hooks/useTranslation';
import FEATURES from 'src/core/constants/features';
import { routeFor, routes } from 'src/core/constants/routes';
import { useCompany } from 'src/core/modules/app/hooks/useCompany';
import { useUser } from 'src/core/modules/app/hooks/useUser';

/**
 * Returns a list of accessible pages within the multi-entity hub settings.
 * If the list is empty, then multi-entity hub settings entry and associated pages shouldn't be display.
 * The order in the list corresponds to that displayed on the multi-entity hub settings header.
 */
export function useOrganisationLinks() {
  const { t } = useTranslation('global');
  const company = useCompany();
  const user = useUser();

  const isCostCentersFeatureEnabled = useFeature(
    FEATURES.COST_CENTERS_ACTIVATED,
  );

  const isMultiEntityConfigFeatureEnabled = useFeature(
    FEATURES.MULTI_ENTITY_CONFIG,
  );

  const links: NavigationLinkProps[] = [];

  if (company.churning_at) {
    return [];
  }
  if (
    isCostCentersFeatureEnabled &&
    isMultiEntityConfigFeatureEnabled &&
    user.is_organisation_owner
  ) {
    links.push({
      key: 'organisation-cost-centers',
      path: routeFor(routes.ORGANISATION_COST_CENTERS.path, {
        company: company.id,
      }),
      text: t('settings.links.costCenters'),
    });
  }

  return links;
}
